import React, {useEffect, useRef, useState} from 'react';
import {
    Card, Divider, List, IconButton, ListItem,
    Icon, ListItemText, Popover, Button, Tooltip, makeStyles
} from "@material-ui/core";
import {DragDropContext, Draggable, Droppable} from 'react-beautiful-dnd'
import FormField from "../../../../../../../Utils/Form/Fields/FormField";
import {set, push, del} from 'object-path-immutable';
import ConditionalFormatSetup from "./ConditionalFormatSetup";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import listRequestWrapper from "../../../../../../../Services/API/listRequestWrapper";
import _ from 'lodash'
import ScriptType from "../../../../../../../Utils/Form/FormDynamic/Fields/ScriptType/ScriptType";
import {useSelector} from "react-redux";
import {multiLanguageValue} from "../../../../../../JsonScreen/Utils/lib";
import {RemoveRedEyeOutlined, VisibilityOff} from "@material-ui/icons";

const useStyles = makeStyles(theme => ({
    cardContentWrapper: {
        height: 485,
        minWidth: 200,
        overflowX: "hidden"
    },
    editIcon: {
        padding: 0
    },
    table: {
        width: '100%',
        //  marginTop: '5px',
        borderSpacing: 0,
        border: '1px solid #fff',
        borderCollapse: 'collapse'
    },
    tableCellLabel: {
        paddingLeft: 10,
        minWidth: '100px',
        border: '1px solid',
        borderColor: '#ebebeb'
    },
    tableCell: {
        minWidth: '100px',
        border: '1px solid',
        borderColor: '#ebebeb'
    },
    formActionsWrapper: {
        margin: '5px 5px 5px 0',
        textAlign: 'right',
    },
    list: {
        paddingTop: 0
    },
    subHeader: {
        lineHeight: 1.32
    },
    advancedFormat: {
        width: '100%',
        transition: theme.transitions.create("all", {
            easing: theme.transitions.easing.easeOut,
            duration: theme.transitions.duration.enteringScreen
        }),
    },
    fieldset: {
        padding: 2,
        border: `1px solid #e5e5e5`,
        boxShadow: 'none',
        height: '100%',
        marginRight: 5
    },
    listItemDense: {
        paddingTop: 0,
        paddingBottom: 0,
        paddingRight: 3
    },
    listItemTextDense: {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        '& > span': {
            display: 'inline'
        }
    }
}))
const defaultInEditColumn = {columnInEdit: {}, anchorEl: null, columnIndex: null, currentOperands: [], isCustom: false};
const columnSchema = {
    name: {
        type: "string",
        name: "name",
        label: "Name",
        path: "name"
    },
    label: {
        type: "string",
        name: "label",
        label: "Label",
        path: "label",
        multiLanguage: true
    },
    type: {
        type: "autocomplete",
        name: "type",
        label: "Type",
        path: "type",
        options: [
            {label: "String", value: "string"},
            {label: "Number", value: "number"},
            {label: "Integer", value: "integer"},
            {label: "Date", value: "date"},
            {label: "Time", value: "time"},
            {label: 'Date Time', value: 'datetime'},
            {label: "Boolean", value: "bool"},
            {label: "Entity External", value: "entityExternal"},
            {label: "Entity Embedded", value: "entityEmbedded"},
            {label: "Entity Mixed", value: "entityMixed"},
            {label: "Object", value: "object"},
            {label: "Text", value: "text"},
            {label: "Duration", value: "duration"},
            {label: "Location", value: "location"},
        ]
    },
    format: {
        type: "string",
        name: "format",
        label: "Format",
        path: "format",
        disabled: false
    },
    width: {
        type: "string",
        name: "width",
        label: "Width",
        path: "width",
        disabled: false
    },
    sticky: {
        type: "switch",
        name: "sticky",
        path: "sticky",
        disabled: false,
    },
    sortable: {
        type: "switch",
        name: "sortable",
        path: "sortable",
        disabled: false,
    },
    quickSearch: {
        type: "switch",
        name: "quickSearch",
        path: "quickSearch",
        disabled: false,
    },
    ignoreTimezoneConversion: {
        type: "switch",
        name: "ignoreTimezoneConversion",
        path: "ignoreTimezoneConversion",
        disabled: false,
    },
    className: {
        type: "string",
        name: "className",
        label: "CSS Class",
        path: "className",
        disabled: false
    },
    hidden: {
        type: "switch",
        name: "hidden",
        path: "hidden",
        disabled: false
    },
    systemUsed: {
        type: "switch",
        name: "systemUsed",
        path: "systemUsed",
        disabled: false
    },
    script: {
        type: 'script',
        name: 'script',
        path: 'script',
    },
    entity: {
        name: 'entity',
        type: 'autocomplete',
        source: 'schema',
        label: 'Entity',
        path: 'entity',
    }
};
const TableColumns = ({columns: sourceColumns, ...props}) => {
    const {removeColumn, setColumnProps, createColumnProps} = props;
    const classes = useStyles();
    const [inEditColumn, setInEditColumn] = useState(defaultInEditColumn)
    const [columns, setColumns] = useState([]);
    const [operands, setOperands] = useState([]);

    useEffect(() => {
        async function getOperands() {
            let operands = await listRequestWrapper('operand');
            setOperands(operands)
        }

        getOperands();
    }, []);

    useEffect(() => {
        setColumns(sourceColumns)
    }, [sourceColumns])

    const openEditColumn = (event, column, index, isCustom) => {
        const currentOperands = operandsByType(operands, column.type);
        setInEditColumn({
            columnInEdit: {...column, calculable: isCustom || column.calculable},
            anchorEl: event.currentTarget,
            columnIndex: index,
            currentOperands,
            isCustom
        })
    };
    const closeEditColumn = () => {
        setInEditColumn(defaultInEditColumn);
    }

    //default form handler
    const onChangeProps = (event, path, isCheckBox) => {
        const newValues = set(inEditColumn, `columnInEdit.${path}`, isCheckBox === true ? event.target.checked : event.target.value);
        setInEditColumn(newValues)
    };
    const onChangeScript = (value, path) => {
        const newValues = set(inEditColumn, `columnInEdit.${path}`, value);
        setInEditColumn(newValues)
    };
    const onChangePropsAutoComplete = (value, path) => {
        let newValues = set(inEditColumn, `columnInEdit.${path}`, value);
        let types = {
            quickSearch: ["string"],
            ignoreTimezoneConversion: ["time", "datetime"]
        };
        if (path === "type") {
            Object.keys(types).map(key => {
                if(inEditColumn.columnInEdit[key] && !types[key].includes(value)) {
                    newValues = set(newValues, `columnInEdit.${key}`, false);
                }
            })
        }
        setInEditColumn(newValues)
    };

    const visibilityChanger = (currentColumn, isVisible, index) => {
        const newValues = set(currentColumn, `hidden`, !isVisible);
        setColumnProps(newValues, index)
    }

    //conditional formatting handlers
    const createCondition = () => {
        const newValues = push(inEditColumn, 'columnInEdit.conditionalFormat', {});
        setInEditColumn(newValues)
    };
    const removeCondition = (index) => {
        const newValues = del(inEditColumn, `columnInEdit.conditionalFormat.${index}`);
        setInEditColumn(newValues)
    };
    const dragEnd = (result) => {
        const {destination, source} = result;
        if (source && destination) {
            const reordered = reorder(inEditColumn.columnInEdit.conditionalFormat, source.index, destination.index);
            const newValues = set(inEditColumn, 'columnInEdit.conditionalFormat', reordered);
            setInEditColumn(newValues)
        }
    };

    const onChangeCriteria = (value, index) => {
        const newValues = set(inEditColumn, `columnInEdit.conditionalFormat.${index}.criteria`, value.id);
        setInEditColumn(newValues)
    };
    const onChangeValue = (event, index) => {
        const newValues = set(inEditColumn, `columnInEdit.conditionalFormat.${index}.value`, event.target.value);
        setInEditColumn(newValues)
    };
    const onChangeFormats = (formats, index) => {
        const allFormats = ['bold', 'italic', 'underlined'];
        const diff = _.difference(allFormats, formats);
        let currentFormats = {};
        allFormats.forEach(format => {
            let finded = false;
            diff.forEach(d => {
                if (d === format) {
                    finded = true
                }
            });
            currentFormats[format] = !finded;
        });
        const newValues = set(
            inEditColumn,
            `columnInEdit.conditionalFormat.${index}.formats`,
            {...inEditColumn.columnInEdit.conditionalFormat[index].formats, ...currentFormats});
        setInEditColumn(newValues)
    };
    const onChangeColor = (color, name, index) => {
        const newValues = set(inEditColumn, `columnInEdit.conditionalFormat.${index}.formats.${name}`, color);
        setInEditColumn(newValues)
    };


    return (
        <>
            <Card className={classes.fieldset}>
                <legend style={{fontWeight: 'bold'}}>
                    Columns
                </legend>
                <Divider/>
                <Droppable droppableId={'columns'}>
                    {(provided) => (
                        <div className={classes.cardContentWrapper}
                             {...provided.droppableProps}
                             ref={provided.innerRef}>
                            <List
                                dense={true}
                                className={classes.list}
                            >
                                <RenderColumns
                                    columns={columns}
                                    openEditColumn={openEditColumn}
                                    visibilityChanger={visibilityChanger}
                                />
                            </List>
                            <div style={{textAlign: "center"}}>
                                <Tooltip title={'Add custom column'}>
                                    <IconButton onClick={(event) => openEditColumn(event, {}, 0, true)}
                                                classes={{root: classes.editIcon}}>
                                        <Icon fontSize={"small"}>
                                            add
                                        </Icon>
                                    </IconButton>
                                </Tooltip>
                            </div>
                            {provided.placeholder}
                        </div>
                    )}
                </Droppable>
            </Card>
            {/*{this.renderFormEditColumn()}*/}
            <EditFormColumn
                closeEditColumn={closeEditColumn}
                inEditColumn={inEditColumn}
                onChangeProps={onChangeProps}
                onChangePropsAutoComplete={onChangePropsAutoComplete}
                onChangeScript={onChangeScript}
                removeColumn={removeColumn}
                setColumnProps={setColumnProps}
                createColumnProps={createColumnProps}
                createCondition={createCondition}
                removeCondition={removeCondition}
                dragEnd={dragEnd}
                onChangeCriteria={onChangeCriteria}
                onChangeValue={onChangeValue}
                onChangeFormats={onChangeFormats}
                onChangeColor={onChangeColor}

            />
        </>
    )
}

const RenderColumns = ({columns = [], openEditColumn, visibilityChanger}) => {
    const classes = useStyles();
    const {userLanguage} = useSelector(state => state.app);
    return (
        columns.map((column, index) => {
            const multiLanguageLabel = multiLanguageValue(column.label, userLanguage)
            return (
                <React.Fragment key={`table_${column.name}_${index}`}>
                    <Draggable
                        draggableId={`${column.name}_columns`}
                        index={index}>
                        {(provided, snapshot) => (
                            <>
                                <ListItem
                                    classes={{dense: classes.listItemDense}}
                                    ref={provided.innerRef}
                                    {...provided.draggableProps}
                                    {...provided.dragHandleProps}
                                    selected={snapshot.isDragging}
                                    onDoubleClick={(event) => openEditColumn(event, column, index)}
                                >
                                    <ListItemText primary={multiLanguageLabel}
                                                  classes={{dense: classes.listItemTextDense}}/>
                                    {column.calculable && (
                                        <Tooltip title={'Calculable Field'}>
                                            <IconButton
                                                size={"small"}
                                                classes={{root: classes.editIcon}}>
                                                <Icon fontSize={"small"}>
                                                    functions
                                                </Icon>
                                            </IconButton>
                                        </Tooltip>
                                    )}
                                    <IconButton
                                        size={"small"}
                                        onClick={() => visibilityChanger(column, column.hidden, index)}
                                    >
                                        {column.hidden ? <VisibilityOff fontSize={"small"}/> :
                                            <RemoveRedEyeOutlined fontSize={"small"}/>}
                                    </IconButton>
                                    <IconButton
                                        size={"small"}
                                        onClick={(event) => openEditColumn(event, column, index)}
                                        classes={{root: classes.editIcon}}>
                                        <Icon fontSize={"small"}>
                                            more_vert
                                        </Icon>
                                    </IconButton>
                                </ListItem>
                                <Divider/>
                            </>
                        )}
                    </Draggable>
                </React.Fragment>
            )
        })
    )
}
const EditFormColumn = ({inEditColumn, closeEditColumn, ...props}) => {
    const classes = useStyles();
    const {
        onChangeProps,
        onChangePropsAutoComplete,
        onChangeScript,
        createColumnProps, removeColumn,
        setColumnProps, createCondition,
        removeCondition,
        dragEnd,
        onChangeCriteria,
        onChangeValue,
        onChangeFormats,
        onChangeColor
    } = props;
    const {anchorEl, columnInEdit} = inEditColumn;
    const [currentTab, setCurrentTab] = useState(0);
    //for update tab indicator
    const actionRef = useRef(null);

    useEffect(() => {
        setTimeout(() => {
            if (actionRef.current && Boolean(anchorEl)) {
                actionRef.current.updateIndicator();
            }
        }, 200)
    }, [actionRef.current, Boolean(anchorEl)]);


    function tabChange(event, value) {
        setCurrentTab(value)
    }

    return (
        <Popover
            open={Boolean(anchorEl)}
            anchorEl={anchorEl}
            PaperProps={{
                style: {width: 420}
            }}
            onClose={closeEditColumn}
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'center',
            }}
            transformOrigin={{
                vertical: 'top',
                horizontal: 'center',
            }}
        >
            <Tabs
                action={actionRef}
                variant={"fullWidth"}
                value={currentTab}
                onChange={tabChange}
                indicatorColor={"primary"}
                style={{minHeight: 30}}
            >
                <Tab
                    style={{minHeight: 30, padding: 0}}
                    label={"Default"}
                    {...a11yProps(0)}/>
                <Tab
                    style={{minHeight: 30, padding: 0}}
                    label={"Conditional Format"}
                    {...a11yProps(1)}/>
            </Tabs>

            {/* Column properties */}
            <TabPanel value={currentTab} index={0}>
                <div style={{display: 'flex'}}>
                    <table className={classes.table}>
                        <tbody>
                        <tr>
                            <td className={classes.tableCellLabel}>{columnSchema.name.label}</td>
                            <td className={classes.tableCell}>
                                <FormField
                                    field={{...columnSchema.name, disabled: !columnInEdit.calculable}}
                                    values={columnInEdit || {}}
                                    onChange={onChangeProps}
                                    path={columnSchema.name.path}
                                />
                            </td>
                        </tr>
                        <tr>
                            <td className={classes.tableCellLabel}>{columnSchema.label.label}</td>
                            <td className={classes.tableCell}>
                                <FormField
                                    field={columnSchema.label}
                                    values={columnInEdit || {}}
                                    onChange={onChangeProps}
                                    path={columnSchema.label.path}
                                />
                            </td>
                        </tr>
                        <tr>
                            <td className={classes.tableCellLabel}>{columnSchema.type.label}</td>
                            <td className={classes.tableCell}>
                                <FormField
                                    field={columnSchema.type}
                                    values={columnInEdit || {}}
                                    onChangeAutoComplete={onChangePropsAutoComplete}
                                    path={columnSchema.type.path}
                                    options={columnSchema.type.options}
                                />
                            </td>
                        </tr>
                        {columnInEdit.type === 'entityExternal' && (
                            <tr>
                                <td className={classes.tableCellLabel}>{columnSchema.entity.label}</td>
                                <td className={classes.tableCell}>
                                    <FormField
                                        field={{
                                            ...columnSchema.entity,
                                            disabled: columnInEdit.type !== 'entityExternal'
                                        }}
                                        values={columnInEdit || {}}
                                        onChangeAutoComplete={onChangePropsAutoComplete}
                                        path={columnSchema.entity.path}
                                        options={columnSchema.entity.options}
                                    />
                                </td>
                            </tr>
                        )}
                        <tr>
                            <td className={classes.tableCellLabel}>{columnSchema.format.label}</td>
                            <td className={classes.tableCell}>
                                <FormField
                                    field={columnSchema.format}
                                    values={columnInEdit || {}}
                                    onChange={onChangeProps}
                                    path={columnSchema.format.path}
                                />
                            </td>
                        </tr>
                        <tr>
                            <td className={classes.tableCellLabel}>{columnSchema.width.label}</td>
                            <td className={classes.tableCell}>
                                <FormField
                                    field={columnSchema.width}
                                    values={columnInEdit || {}}
                                    onChange={onChangeProps}
                                    path={columnSchema.width.path}
                                />
                            </td>
                        </tr>
                        <tr>
                            <td className={classes.tableCellLabel}>Sticky</td>
                            <td className={classes.tableCell}>
                                <FormField
                                    field={columnSchema.sticky}
                                    values={columnInEdit || {}}
                                    onChange={onChangeProps}
                                    path={columnSchema.sticky.path}
                                />
                            </td>
                        </tr>
                        <tr>
                            <td className={classes.tableCellLabel}>Sortable</td>
                            <td className={classes.tableCell}>
                                <FormField
                                    field={columnSchema.sortable}
                                    values={columnInEdit || {}}
                                    onChange={onChangeProps}
                                    path={columnSchema.sortable.path}
                                />
                            </td>
                        </tr>
                        {
                            (columnInEdit.type === 'string' || columnInEdit.type === 'entityExternal') && (
                                <tr>
                                    <td className={classes.tableCellLabel}>Quick Search</td>
                                    <td className={classes.tableCell}>
                                        <FormField
                                            field={columnSchema.quickSearch}
                                            values={columnInEdit || {}}
                                            onChange={onChangeProps}
                                            path={columnSchema.quickSearch.path}
                                        />
                                    </td>
                                </tr>
                            )
                        }
                        {
                            (columnInEdit.type === 'time' || columnInEdit.type === 'datetime') && (
                                <tr>
                                    <td className={classes.tableCellLabel}>Ignore Timezone Conversion</td>
                                    <td className={classes.tableCell}>
                                        <FormField
                                            field={columnSchema.ignoreTimezoneConversion}
                                            values={columnInEdit || {}}
                                            onChange={onChangeProps}
                                            path={columnSchema.ignoreTimezoneConversion.path}
                                        />
                                    </td>
                                </tr>
                            )
                        }
                        <tr>
                            <td className={classes.tableCellLabel}>{columnSchema.className.label}</td>
                            <td className={classes.tableCell}>
                                <FormField
                                    field={columnSchema.className}
                                    values={columnInEdit || {}}
                                    onChange={onChangeProps}
                                    path={columnSchema.className.path}
                                />
                            </td>
                        </tr>
                        <tr>
                            <td className={classes.tableCellLabel}>Hidden</td>
                            <td className={classes.tableCell}>
                                <FormField
                                    field={columnSchema.hidden}
                                    values={columnInEdit || {}}
                                    onChange={onChangeProps}
                                    path={columnSchema.hidden.path}
                                />
                            </td>
                        </tr>
                        <tr>
                            <td className={classes.tableCellLabel}>System Used</td>
                            <td className={classes.tableCell}>
                                <FormField
                                    field={columnSchema.systemUsed}
                                    values={columnInEdit || {}}
                                    onChange={onChangeProps}
                                    path={columnSchema.systemUsed.path}
                                />
                            </td>
                        </tr>
                        {columnInEdit.calculable && (
                            <tr>
                                <td className={classes.tableCellLabel}>Script</td>
                                <td className={classes.tableCell}>
                                    <ScriptType
                                        field={{
                                            path: columnSchema.script.path,
                                            type: "script"
                                        }}
                                        fieldStyles={{withoutStyles: true, fullWidth: true}}
                                        showLabel
                                        setValue={onChangeScript}
                                        values={columnInEdit || {}}
                                    />
                                </td>
                            </tr>
                        )}
                        </tbody>
                    </table>
                </div>
            </TabPanel>

            {/* Column conditional formatting setup */}
            <TabPanel value={currentTab} index={1}>
                <Divider/>
                <div className={classes.advancedFormat} style={{
                    width: '100%',
                    height: 208,
                    overflow: 'auto',
                    borderBottom: '1px solid rgba(0,0,0,0.07)'
                }}>
                    <DragDropContext onDragEnd={dragEnd}>
                        <Droppable droppableId="conditional_render">
                            {(provided) => (
                                <div
                                    {...provided.droppableProps}
                                    ref={provided.innerRef}
                                >
                                    <ConditionalFormatSetup
                                        createCondition={createCondition}
                                        removeCondition={removeCondition}
                                        currentOperands={inEditColumn.currentOperands}
                                        conditions={columnInEdit ? columnInEdit.conditionalFormat : []}
                                        onChangeCriteria={onChangeCriteria}
                                        onChangeValue={onChangeValue}
                                        onChangeFormats={onChangeFormats}
                                        onChangeColor={onChangeColor}
                                    />
                                    {provided.placeholder}
                                </div>
                            )}
                        </Droppable>
                    </DragDropContext>
                    <AddNewCondition createCondition={createCondition}/>
                </div>
            </TabPanel>
            <FormAction
                inEditColumn={inEditColumn}
                createColumnProps={createColumnProps}
                closeEditColumn={closeEditColumn}
                removeColumn={removeColumn}
                setColumnProps={setColumnProps}
            />
        </Popover>
    )
}
const FormAction = ({inEditColumn, createColumnProps, setColumnProps, removeColumn, closeEditColumn}) => {
    const classes = useStyles();
    const {columnInEdit, columnIndex, isCustom} = inEditColumn;
    return (
        <div className={classes.formActionsWrapper}>
            <Button size={"small"} variant="contained" color="primary" onClick={() => {
                isCustom ? createColumnProps(columnInEdit) : setColumnProps(columnInEdit, columnIndex);
                closeEditColumn();
            }}>Apply</Button>
            {!isCustom && (
                <Button size={"small"} variant="contained" color="default" onClick={() => {
                    removeColumn(columnIndex);
                    closeEditColumn();
                }}
                        style={{margin: "0 0 0 10px"}}
                >
                    Remove
                </Button>
            )}

            <Button size={"small"} variant="contained" color="default" onClick={closeEditColumn}
                    style={{margin: "0 0 0 10px"}}>
                Cancel
            </Button>
        </div>
    )
}

export default TableColumns

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

function TabPanel(props) {
    const {children, value, index, ...other} = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <div>{children}</div>
            )}
        </div>
    );
}

function operandsByType(operands = [], type) {
    let operandsByType = [];
    if (type) {
        operands.forEach(op => {
            if (!op.type) {
                operandsByType.push(op)
            } else {
                op.type.forEach(t => {
                    if (t === type.toUpperCase()) {
                        operandsByType.push(op)
                    }
                })
            }
        });
        return operandsByType
    } else {
        return operands;
    }


}

const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);
    return result;

};

const AddNewCondition = (props) => {
    return (
        <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', height: '30px'}}>
            <Tooltip title={'Create new condition'}>
                <IconButton
                    onClick={props.createCondition}
                    style={{padding: 0, margin: 0}}
                >
                    <Icon
                        style={{padding: 0, margin: 0}}
                        fontSize={"small"}
                    >
                        add
                    </Icon>
                </IconButton>
            </Tooltip>
        </div>
    )
};